import { Component, Input } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { Globals } from '../../../globals';
import { AdsServices } from '../services';
import { ProviderFilePage } from '../provider-file/provider-file';

/**
 * Generated class for the DishViewAllergensPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
    selector: 'page-provider-dashboard',
    templateUrl: 'provider-dashboard.html',
})
export class ProviderDashboardPage {

    @Input() position;
    @Input() num_ads;

    providers_top: any;
    providers_bot: any;

    constructor(public navCtrl: NavController,
        public navParams: NavParams,
        public globals: Globals,
        public adsServices: AdsServices) {

        
    }

    async ngOnInit(){
        await this.getElements(parseInt(this.num_ads));
    }

    async getElements(num_ads) {
        //Recuperamos los proveedores
        const providerAds = await this.adsServices.getProvidersAds(num_ads, 'Dashboard');
        this.adsServices.actual_page = 'Dashboard';
        
        //Comprovamos la posicion para que no se repitan los ads
        if(this.position == 'top'){
            this.providers_top = providerAds;
        }else{
            this.providers_bot = providerAds;
        }
    }

    openProviderFile(provider) {       
        
        this.navCtrl.push(ProviderFilePage, {
            provider: provider
        });
    }

}



// WEBPACK FOOTER //
// ./src/pages/ads/provider-dashboard/provider-dashboard.ts